module.exports = __webpack_public_path__ + "static/img/content.ff8735f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/application_intro/content.png
// module id = I9+O
// module chunks = 0